import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ThemeSwitch from "./ThemeSwitch";
import { Menu, X } from "lucide-react";

function Navbar() {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang).catch((err) =>
      console.error("Erreur lors du changement de langue :", err)
    );
  };

  return (
    <nav className="bg-[#F9F5F6] text-gray-900 dark:bg-gray-900 dark:text-white shadow-md fixed w-full z-50">
      <div className="container mx-auto flex justify-between items-center p-4">
        {/* Logo principal */}
        <Link to="/">
          <img src="/images/Lizay.png" alt="Lizay Logo" className="h-20 w-auto" />
        </Link>

        {/* Bouton hamburger pour mobile */}
        <button className="lg:hidden focus:outline-none" onClick={toggleMenu}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Menu principal (visible sur desktop) */}
        <ul className="hidden lg:flex space-x-6 text-lg">
          <li>
            <Link to="/" className="hover:text-blue-600 transition">{t("home")}</Link>
          </li>
          <li>
            <Link to="/about" className="hover:text-blue-600 transition">{t("about")}</Link>
          </li>
          <li>
            <Link to="/services" className="hover:text-blue-600 transition">{t("services")}</Link>
          </li>
          <li>
            <Link to="/portfolio" className="hover:text-blue-600 transition">{t("portfolio")}</Link>
          </li>
          
          <li>
            <Link to="/contact" className="hover:text-blue-600 transition">{t("contact")}</Link>
          </li>
        </ul>

        {/* Actions (Langue & Dark Mode) */}
        <div className="hidden lg:flex items-center space-x-4">
          <button onClick={() => changeLanguage("en")} className="mr-2 hover:text-blue-600">
            🇺🇸 EN
          </button>
          <button onClick={() => changeLanguage("fr")} className="hover:text-blue-600">
            🇫🇷 FR
          </button>
          <ThemeSwitch />
        </div>
      </div>

      {/* Menu mobile qui descend depuis le haut */}
      <div
        className={`lg:hidden fixed top-0 left-0 w-full bg-[#F9F5F6] dark:bg-gray-800 text-gray-900 dark:text-white shadow-md transition-transform duration-300 ${
          isOpen ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="flex justify-between items-center p-4">
          {/* Logo dans le menu mobile */}
          <img src="/images/Lizay.png" alt="Lizay Logo" className="h-20 w-auto" />

          {/* Bouton pour fermer le menu */}
          <button className="focus:outline-none" onClick={toggleMenu}>
            <X size={28} />
          </button>
        </div>

        <ul className="flex flex-col space-y-6 text-lg items-center mt-4">
          <li>
            <Link to="/" className="hover:text-blue-600 transition" onClick={toggleMenu}>
              {t("home")}
            </Link>
          </li>
          <li>
            <Link to="/about" className="hover:text-blue-600 transition" onClick={toggleMenu}>
              {t("about")}
            </Link>
          </li>
          <li>
            <Link to="/services" className="hover:text-blue-600 transition" onClick={toggleMenu}>
              {t("services")}
            </Link>
          </li>
          <li>
            <Link to="/portfolio" className="hover:text-blue-600 transition" onClick={toggleMenu}>
              {t("portfolio")}
            </Link>
          </li>
          
          <li>
            <Link to="/contact" className="hover:text-blue-600 transition" onClick={toggleMenu}>
              {t("contact")}
            </Link>
          </li>
        </ul>

        <div className="flex justify-center items-center mt-6 space-x-4">
          {/* Changement de langue */}
          <button onClick={() => changeLanguage("en")} className="hover:text-blue-600">
            🇺🇸 EN
          </button>
          <button onClick={() => changeLanguage("fr")} className="hover:text-blue-600">
            🇫🇷 FR
          </button>
          {/* Switch Dark Mode */}
          <ThemeSwitch />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
